export default "__VITE_ASSET__DBgsnxsU__"